// colors

import { createTheme } from "@mui/material";

export const primaryColor = "#708090";
export const whiteColor = "#FFFFFF";
export const tertiaryColor = "#9774a8";
export const secondaryColor = "#3a93c9";
export const orangeColor = "#FFA500";

export const darkColor = "#212631";
export const blueColor = "#1b75bb";
export const darkBlueColor = "#273239";
export const goldColor = "#FFD700";

export const antdTheme = {
  token: {
    colorPrimary: primaryColor,
  },
  components: {
    Button: {
      // primaryColor: "#000",
      // colorTextLightSolid: "#000",
      //   colorPrimaryHover: darkColor,
    },
  },
};

export const themeMui = createTheme({
  palette: {
    // mode: "dark",
    primary: {
      main: primaryColor,
    },
  },
  typography: {
    // fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: 13,
    button: {
      textTransform: "none",
    },
  },
});
